import React from 'react';
import './VersionHistoryModal.css';
import versionHistory from '../../data/versionHistory.json';
import { format, parse } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const VersionHistoryModal = ({ onClose }) => {
  const formatDate = (dateString) => {
    const dateObj = parse(dateString, 'yyyy-MM-dd HH:mm', new Date());
    const zonedDate = toZonedTime(dateObj, 'America/New_York');
    return format(zonedDate, 'MMM dd, yyyy, hh:mm a');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Update History</h2>
          <button className="modal-close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          {versionHistory.map((item, index) => (
            <div className="history-item" key={index}>
              <div className="history-item-header">
                <span className="history-version">{item.version}</span>
                <span className="history-date">{formatDate(item.date)}</span>
              </div>
              <p className="history-notes">{item.notes}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VersionHistoryModal; 